// extracted by mini-css-extract-plugin
module.exports = {"product-search-refinement-sorting-select-listbox":"ProductSearchRefinementSortingSelectListbox_product-search-refinement-sorting-select-listbox__xSTBh"};